import React from 'react';
import Scroll	from "react-scroll";
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';

import AboutYourself from './panels/AboutYourself';
import SelectInsuranceCover from './panels/SelectInsuranceCover';
import CompareCover from './panels/CompareCover';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      step1Inactive: false,
      step2Inactive: true,
      step3Inactive: true,
      panel1Edit: false,
      panel2Edit: false,
      panel3Edit: false,
      userInputs: {},
      insuranceCoverInputs: {},
      disableNext: true,
      results: {}
    };

    this.onChildChanged = this.onChildChanged.bind(this);
    this.onSelectInsuranceChange = this.onSelectInsuranceChange.bind(this);
    this.panelUpdate = this.panelUpdate.bind(this);
    this.panel1Edit = this.panel1Edit.bind(this);
    this.panel2Update = this.panel2Update.bind(this);
    this.resultsUpdate = this.resultsUpdate.bind(this);

}

  componentDidMount() {
    Events.scrollEvent.register('begin', function(to, element) {      
    });
  }

  componentWillUnmount() {
    this.props.scrollEvents.scrollEvent.remove('begin');
    this.props.scrollEvents.scrollEvent.remove('end');
  }

  onChildChanged(newState) {
    this.setState({ userInputs: newState});
  }

  onSelectInsuranceChange(newState) {
    this.setState({
      insuranceCoverInputs: newState
    });
  }

  onInsuranceCoverShow(newState) {
    this.setState({
      insuranceCoverShow: newState
    });
  }

  panelUpdate(newState) {          
    if(this.state.panel1Edit == true && this.state.step1Inactive == true) {
      this.setState({
        step1Inactive: false,
        step2Inactive: true,
        step3Inactive: true,
        panel1Edit: false,
        panel2Edit: false
      });
    } else {
      this.setState({
        step1Inactive: newState,
        step2Inactive: false,
        panel1Edit: newState,
        panel2Edit: false
      });
    }

    if(this.state.userInputs.age != null && this.state.userInputs.existingMember == 1 && this.state.userInputs.occupationalRating != null && this.state.userInputs.police == 1) {
      this.setState({
        disableNext: false
      });
    }

    scroll.scrollTo('scrollto-2', {
      delay: 100,
      smooth: true,
      containerId: 'App'
    });
    }

    panel1Edit(newState) {
      this.setState({});      
    }

    panel2Update(newState) {
      if(this.state.panel2Edit === true && this.state.step2Inactive === true) {
        this.setState({
          step1Inactive: true,
          step2Inactive: false,
          step3Inactive: true,
          panel2Edit: false
        });
      } else {
        this.setState({
          panel2Edit: newState,
          step3Inactive: false,
          step2Inactive: newState
        });
        setTimeout(function(){
          scroll.scrollTo('scrollto-3', {
            smooth: true,
            containerId: 'App'
          });
       }, 1000);
      }
    }

  resultsUpdate(newState) {
    this.setState({results: newState});
  }


  render() {
    return (
        <div className="app">
          <Element name="scrollto-1" className="element" />
          <AboutYourself
          panel1Edit={this.state.panel1Edit}
          step1Inactive={this.props.step1Inactive}
          panelVisible={this.panelUpdate}
          callbackParent={this.onChildChanged}
          disableNext={this.state.disableNext} />


          <Element name="scrollto-2" className="element" />
          <SelectInsuranceCover
          panel2Edit={this.state.panel2Edit}
          step2Inactive={this.state.step2Inactive}
          step3Inactive={this.state.step3Inactive}
          userInputs={this.state.userInputs}
          panel2Visible={this.panel2Update}
          callbackParent={this.onSelectInsuranceChange}
          callbackCoverShow={this.onInsuranceCoverShow} />


          <Element name="scrollto-3" className="element" />
          <CompareCover
          step1Inactive={this.state.step1Inactive}
          step2Inactive={this.state.step2Inactive}
          step3Inactive={this.state.step3Inactive}
          insuranceCoverShow={this.state.insuranceCoverShow}
          results={this.state.results}
          userInputs={this.state.userInputs}
          insuranceCoverInputs={this.state.insuranceCoverInputs} />

        </div>
    );
  }
}
App.defaultProps = {
  Events: Scroll.Events,
	scroll: Scroll.animateScroll,
  scrollSpy: Scroll.scrollSpy,
  Element: Scroll.Element
};

App.propTypes = {
  scrollEvents: React.PropTypes.func
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js